import React, { Component } from 'react';
import logo from './logo.svg';
import appStoreLogo from './AppleAppStore.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p className="App-header-text">
            Maxal Labs, LLC
          </p>
        </header>
        <div className="App-text">
          <p>
              Welcome!
          </p>
          <p>
            Do you need mobile application that could collect some data and send it to your system? We can do this for you.
          </p>
          <p>
            You can look at our applications at store:
          </p>
        </div>
        <div className="App-apps">
        <p className="App-app-name">
          Tennis Umpire App
        </p>
        <div className="App-store-container">
                <a
                href='https://play.google.com/store/apps/details?id=com.tennisumpireapp'>
                    <img className="App-download-img" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' />
                </a>

                <a href="https://itunes.apple.com/us/app/tennis-umpire-app/id1316338557">
                    <img src={appStoreLogo} alt="Get it in Apple Store" />
                </a>

                <a href="https://www.microsoft.com/store/apps/9wzdncrdlvsx?ocid=badge">
                    <img className="App-download-img"
                        src="https://assets.windowsphone.com/13484911-a6ab-4170-8b7e-795c1e8b4165/English_get_L_InvariantCulture_Default.png" alt="Get it in Microsoft Store" />
                </a>

            </div>
        </div>
        <div className="App-apps">
        <p className="App-app-name">
          ScoreLink
        </p>
        <div className="App-store-container">
                <a
                href='https://play.google.com/store/apps/details?id=com.maxal_labs.scorelink'>
                    <img className="App-download-img" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' />
                </a>
                
                <a href="https://itunes.apple.com/us/app/tennis-umpire-app/id1412941650">
                    <img src={appStoreLogo} alt="Get it in Apple Store" />
                </a>
            </div>
        </div>
        <div className="App-contact-us">
        <p className="App-text">
          Contact us:
        </p>
            <a href="mailto:contact@maxal-labs.com">contact@maxal-labs.com</a>
        </div>
      </div>
    );
  }
}

export default App;
